export const isWizardStepValid = ({
  currentStep,
  clientMappings,
  selectedDocType,
  uploadedFiles,
  processRows,
  processGeneration,
  vocabularyRows,
  vocabularyGeneration,
  downloadReady,
}) => {
  switch (currentStep) {
    case 0:
      return clientMappings.filter((mapping) => mapping.enabled).length > 0;
    case 1:
      return Boolean(selectedDocType) && uploadedFiles.length > 0;
    case 2:
      return processRows.length > 0 && !processGeneration.running;
    case 3:
      return vocabularyRows.length > 0 && !vocabularyGeneration.running;
    case 4:
      return true;
    case 5:
      return downloadReady;
    default:
      return true;
  }
};
